/**
 * Shuttle-strategy header (ADR 0005). The strategy a job's payload follows rides
 * as a labelled input row in the otherwise-opaque payload. Loom stamps it when a
 * node enqueues; the Shuttle reads it to demux to the executor that handles that
 * strategy. Jobs never reads it.
 */

export const SHUTTLE_STRATEGY_LABEL = 'shuttle-strategy';

/** The canonical AI strategy: render a prompt, run inference, return structured output. */
export const PROMPT_EXECUTION_STRATEGY = 'prompt-execution';

/** Build the strategy header input row (authoring side). */
export function shuttleStrategyInput(strategy: string): {
  label: string;
  origin: 'raw';
  payload: Record<string, unknown>;
} {
  return { label: SHUTTLE_STRATEGY_LABEL, origin: 'raw', payload: { strategy } };
}

/** Read the strategy header off a dispatched job's inputs (runtime side). Null if absent. */
export function readShuttleStrategy(
  inputs: Array<{ label: string | null; payload: Record<string, unknown> }>,
): string | null {
  const row = inputs.find((i) => i.label === SHUTTLE_STRATEGY_LABEL);
  if (!row) return null;
  const strategy = (row.payload as { strategy?: unknown }).strategy;
  return typeof strategy === 'string' ? strategy : null;
}
